import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, QueryList, SimpleChanges, ViewChildren, AfterViewInit } from "@angular/core";
import { EscolhaVinculo1RadioOptionElement } from "../FakeChildClassRadioOption";


export interface VinculosAndIndexVM {
  vinculo: models.VinculoServicoVM;
  index: number;

}
@Component({
    selector: 'vinculos-list',
    templateUrl: './vinculos-list.component.html',
    styleUrls: ['./vinculos-list.component.scss'],
    standalone: false
})



export class VinculosListComponent implements OnDestroy, AfterViewInit {

  @Input() subscriberServices: models.VinculoServicoVM[];
  @Input() chaveServicoEscolhido: string;
  @Input() finalService: models.VinculoServicoVM;
  @Input() suggestedService: models.VinculoServicoVM;
  @Input()
  public isEnabled: boolean = false;
  @Output() public onOptionClicked: EventEmitter<VinculosAndIndexVM> = new EventEmitter();
  @Input() set externalReseter(reset: boolean) {
    if (reset) this.resetOptions("0");
  }




  ngAfterViewInit() {
    this.selectServicoEscolhidoIfExists();
  }

  @ViewChildren(EscolhaVinculo1RadioOptionElement, { read: ElementRef })
  private escolhaVinculoItens: QueryList<ElementRef>;


  optionClicked(entry: models.VinculoServicoVM, index: number) {
    this.resetOptions(entry.chaveServico + entry.servInicialChave);
    this.onOptionClicked.emit({ vinculo: entry, index });
  }

  ngOnDestroy(): void {

  }

  public isItemValid(vinculo: models.VinculoServicoVM): boolean {
    let result: boolean = this.isEnabled && vinculo.estado !== "D" && !(vinculo.estado == 'A' &&
      (
      (vinculo.registadoCGADIR == '0' && vinculo.numSubsAtivos == '0')
      || (vinculo.registadoCGADIR == '0')
      || (vinculo.numSubsAtivos == '0')
      )
    );
    return result;
  }

  public getTableItemEstado(tableItem: models.VinculoServicoVM, isServInicial: boolean): string{
    var serv = isServInicial ? [this.suggestedService, ...this.subscriberServices].find(s => s.chaveServico == tableItem.servInicialChave && s.servIntegracoesList.find(se => se.chaveServico == tableItem.chaveServico)) : tableItem;


    if (serv.estado == 'A' && ((serv.registadoCGADIR == '0' && serv.numSubsAtivos == '0') || (serv.registadoCGADIR == '0') || (serv.numSubsAtivos == '0'))
      && !isServInicial) {
      return "Não elegível";
    }
    if (serv.estado == 'A' && !((serv.registadoCGADIR == '0' && serv.numSubsAtivos == '0') || (serv.registadoCGADIR == '0') || (serv.numSubsAtivos == '0'))
      &&
      (
        (serv.servIntegracoesList == null || serv.servIntegracoesList == undefined || serv.servIntegracoesList.length == 0)
        ||
        (serv.servIntegracoesList != null && serv.servIntegracoesList.length > 0 && !isServInicial)
      )
    ) {
      return "Ativo";
    }

    if (serv.estado == 'D' && (serv.servIntegracoesList != null && serv.servIntegracoesList.length > 0 && !isServInicial))
    {
      return "Inativo";

    }
    if (serv.estado == 'D' &&  (serv.servIntegracoesList == null || serv.servIntegracoesList == undefined || serv.servIntegracoesList.length == 0)) {
      return "Extinto";
    }

    if ((serv.servIntegracoesList != null && serv.servIntegracoesList.length > 0) && (serv.servIntegracoesList[0].servInicialEstado == 'R') && isServInicial) {
      return "Redirecionado";
    }

    if ((serv.estado == 'A' || serv.estado == 'D') && (serv.servIntegracoesList != null && serv.servIntegracoesList.length > 0) && isServInicial) {
      return "Integrado";
    }
  }

  public resetOptions(entryCode?: string) {
      this.escolhaVinculoItens
        .filter(el => (entryCode== null) ||  el.nativeElement.alt != entryCode)
    .forEach(el => el.nativeElement.checked = false);
  }

  public selectServicoEscolhidoIfExists() {
    this.escolhaVinculoItens
      .filter(el => {
        return this.chaveServicoEscolhido != null &&
          (el.nativeElement.alt == (this.chaveServicoEscolhido + (this.suggestedService?.chaveServico ?? 'undefined')) ||
          el.nativeElement.alt == (this.chaveServicoEscolhido +  'undefined'))
      })
      .forEach(el =>
        el.nativeElement.checked = true
      );
  }
}
